import React from "react";
import SingleCard from "./SingleCard";
import Img1 from "../../../../../assets/BVR_22753.png";
import { Box } from "@chakra-ui/react";
import FeasibilityForm from "./FeasibilityForm";
import { convertDataFormat, getMinioImage } from "../../../../../utils/helpers";
import MasonaryWrapper from "../../../../../components/MasonaryWrapper";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useFormContext } from "../FormStateContext";

function SiteFeasibility({
  activeTab,
  data,
  setActiveTab,
  isRandom = false,
  fetchPresentationData,
  handlePublicLink,
  duplicatePresentation,
}) {
  // console.log({fetchPresentationData, fn}, "SITE");
  const { setTab } = useFormContext();
  let backendData = data ? [...data] : [];
  data = data && data?.length > 0 && data?.map((v) => convertDataFormat(v));
  // console.log(backendData, data, "DATA SITE");

  return (
    <Box>
      {/* <>
      {activeTab.index == 0 && !activeTab.showForm ? (
        // <div className={`flex ${isRandom ?" flex-row flex-wrap " :" flex-col "}  gap-5`}>
        // <div className={` ${isRandom ?" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-2 " :" flex flex-col gap-5 "} `}>

  
 <MasonaryWrapper>
          {Array.isArray(data) &&
            data?.length > 0 &&

            data.map((item, index) => (
              <SingleCard
                images={[Img1, Img1, Img1, Img1]}
                randomImages= {isRandom ? item.buildingData.map(v=> v.image.map(i=> getMinioImage(i))).flat() || [] : []}
                label={"Site Feasibility Report"}
                key={index}
                data={item}
                isRandom={isRandom}
                fetchPresentationData={fetchPresentationData}
                handlePublicLink= {()=> handlePublicLink(`site/${item?._id}/${item?.companyName}`)}
                handleEdit={(id) =>
                  setActiveTab((p) => ({ ...p, showForm: true, isEditId: id }))
                }
                activeTabIdx={activeTab?.index}
              />
            ))}
           </MasonaryWrapper>
       
      ) : (
        <FeasibilityForm
          isEdit={activeTab?.isEditId}
          isRandom={isRandom}
          data={data}
          handlePublicLink={handlePublicLink}
          setActiveForm={() => {
            setActiveTab((prev) => ({
              ...prev,
              // showForm: false,
              // isEditId: null,
              isRender: !prev?.isRender,
            }));
          }}
          storeActiveTab= { ()=> 
            setTab(activeTab)
            // sessionStorage.setItem('activetab', JSON.stringify(activeTab))
          }
        />
      )}
      </> */}

      <MasonaryWrapper>
        {Array.isArray(data) &&
          data?.length > 0 &&
          data.map((item, index) => (
            <SingleCard
              duplicatePresentation={duplicatePresentation}
              images={[Img1, Img1, Img1, Img1]}
              randomImages={item.images}
              // randomImages= {isRandom ? item.buildingData.map(v=> v.image.map(i=> getMinioImage(i))).flat() || [] : []}
              label={"Site Feasibility Report"}
              key={index}
              data={item}
              isRandom={isRandom}
              // fetchPresentationData={fetchPresentationData}
              handlePublicLink={() =>
                handlePublicLink(`site/${item?._id}/${item?.companyName}`)
              }
              handleEdit={(id) =>
                setActiveTab((p) => ({ ...p, showForm: true, isEditId: id }))
              }
              activeTabIdx={activeTab?.index}
            />
          ))}
      </MasonaryWrapper>
    </Box>
  );
}

export default SiteFeasibility;

let obj = {
  images: [], // all images inside data at any level
  formData: [
    {
      heading: "Heading",

      tableData: [
        { label: "Label1", value: "Value1" },
        { label: "Label2", value: "Value2" },
      ],
      remarks: "Heelo from remarks",
      images: [
        "https://plus.unsplash.com/premium_photo-1700996706577-c299866f294e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1758566486732-c6bcc1d080e1?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      ], // here image of that heading level
    },
  ],
};

// Example usage:
/*
const data1 = { ... }; // Your data1 object
const convertedData = convertDataFormat(data1);
console.log(JSON.stringify(convertedData, null, 2));
*/

// Example usage:
/*
const data1 = { ... }; // Your data1 object
const convertedData = convertDataFormat(data1);
console.log(JSON.stringify(convertedData, null, 2));
*/

// Example usage:
/*
const data1 = { ... }; // Your data1 object
const convertedData = convertDataFormat(data1);
console.log(JSON.stringify(convertedData, null, 2));
*/
// Example usage:
/*
const data1 = { ... }; // Your data1 object
const convertedData = convertDataFormat(data1);
console.log(JSON.stringify(convertedData, null, 2));
*/
